import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=221cb5c6&scoped=true"
import script from "./sButton.ts?vue&type=script&lang=ts&external"
export * from "./sButton.ts?vue&type=script&lang=ts&external"
import style0 from "./SButton.vue?vue&type=style&index=0&id=221cb5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cb5c6",
  null
  
)

export default component.exports